import { computed } from 'vue';
import { useRoute } from 'vue-router';

/**
 * A list of route paths where the search box should be hidden.
 */
const hiddenPaths: string[] = [
  '/business',
  '/experts',
  '/pricing',
  '/services'
];

/**
 * A composable function to determine if the search box should be shown.
 */

export function useSearchBoxVisibility() {
  const route = useRoute();

  const showSearchBox = computed(() => {
        return !hiddenPaths.some(prefix => route.path.startsWith(prefix));
  });

  return {
    showSearchBox,
  };
}
